
















































import { Component, Prop, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import { chunk } from 'lodash'

@Component
export default class DatePicker extends Vue {
  @Prop({
    default () { return [] }
  }) disabledDate!: string[]

  @Prop({ default () { return new Set() } }) selected!: Set<string>
  private stands = dayjs()
  private toDay = dayjs()
  get monthIndex () {
    return this.stands.get('month') + 1
  }
  get yearIndex () {
    return this.stands.get('y')
  }
  getCurrentCalender () {
    let start = this.stands.startOf('month')
    let end = this.stands.endOf('month')
    let range = Array.from({ length: end.get('date') - start.get('date') + 1 }).map((_, i) => {
      let d = start.add(i, 'day')
      return {
        value: d.format('YYYY-MM-DD'),
        display: '' + d.get('date'),
        week: d.get('day'),
        isBefore: d.isBefore(this.toDay),
        disabled: !!~this.disabledDate.indexOf(d.format('YYYY-MM-DD'))
      }
    })
    let padding = range[0].week === 0 ? 0 : range[0].week
    let pending = 6 - range[range.length - 1].week === 6 ? 0 : 6 - range[range.length - 1].week
    return chunk([...Array(padding).fill({ value: '', display: '', week: -1, isBefore: true }), ...range, ...Array(pending).fill({ value: '', display: '', week: -1 })], 7)
  }
  forwardOnClick () {
    this.stands = this.stands.add(1, 'month')
  }
  backwardOnClick () {
    if (!dayjs().isBefore(this.stands.subtract(1, 'month').endOf('month'))) {
      return false
    } else {
      this.stands = this.stands.subtract(1, 'month')
    }
  }
  dateOnClick (col: { value: string, display: string, week: number, isBefore: boolean, disabled: boolean }) {
    if (col.isBefore || col.disabled) return false
    console.log(col.value)
    if (!this.selected.has(col.value)) {
      this.$emit('add', col.value)
    } else {
      this.$emit('remove', col.value)
    }
  }
}
